import { DeleteConnectedAppRequest, GetConnectedAppsResponse } from '@cms-max/medicare-api-sdk'
import { AxiosError } from 'axios'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export const getConnectedAppsQueryKey = 'getConnectedApps'

export const useGetConnectedApps = () => {
  const fetchConnectedApps = async () => {
    const res = await medicareApiClient.connectedAppsApi.getConnectedApps()
    return res.data
  }

  return useQuery<GetConnectedAppsResponse | undefined>(
    getConnectedAppsQueryKey,
    fetchConnectedApps
  )
}

export const useDeleteConnectedApp = () => {
  const queryClient = useQueryClient()
  const deleteConnectedApps = async ({ id }: DeleteConnectedAppRequest) => {
    const res = await medicareApiClient.connectedAppsApi.deleteConnectedApp({ id })
    return res.data
  }
  return useMutation<boolean, AxiosError, DeleteConnectedAppRequest>(
    {
      mutationFn: deleteConnectedApps,
      onMutate: ({ id }) => {
        queryClient.setQueryData<GetConnectedAppsResponse>(
          [getConnectedAppsQueryKey],
          (old) => ({
            apps: old?.apps.filter((app) => app.id + '' !== id) ?? []
          })
        )
      },
      onSettled: () => {
        queryClient.invalidateQueries([getConnectedAppsQueryKey])
      }
    }
  )
}
